import { useContext } from 'react';
import inputContext from '../contexts/inputContext';

const useInputContext = () => {
  return useContext(inputContext);
};

export default useInputContext;
